import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { Router, Route, IndexRoute, browserHistory } from 'react-router'
import './css/main.css';

// Views
import App from './App.js';
import AlarmDetail from './views/AlarmDetail';
import AlarmListing from './views/AlarmListing';
import AlarmSounding from './views/AlarmSounding';
import Home from './views/Home';
import Settings from './views/Settings';
import TaskListing from './views/TaskListing';
import Weather from './views/Weather';

// Stores
import AlarmStore from './stores/AlarmStore';
import SettingsStore from './stores/SettingsStore';
import WeatherStore from './stores/WeatherStore';

ReactDOM.render((
  <Provider
    alarmStore={new AlarmStore()}
    settingsStore={new SettingsStore()}
    weatherStore={new WeatherStore()}>
    <Router history={browserHistory}>
      <Route component={App}>
        <Route path='/' component={Home} />
        <Route path='/alarms'>
          <IndexRoute component={AlarmListing} />
          <Route path='new' component={AlarmDetail} />
          <Route path=':id' component={AlarmDetail} />
        </Route>
        <Route path='/alarm/:id' component={AlarmSounding} />
        <Route path='/settings' component={Settings} />
        <Route path='/tasks' component={TaskListing} />
        <Route path='/weather' component={Weather} />
      </Route>
    </Router>
  </Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js